import { render, staticRenderFns } from "./AreaPlantadaBunge.vue?vue&type=template&id=c783c15a&lang=pug"
import script from "./AreaPlantadaBunge.vue?vue&type=script&lang=js"
export * from "./AreaPlantadaBunge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports